import useAxios from "../../hooks/useAxios";

const useQuickLinkService = () => {
  const axiosList = useAxios();
  const axiosCreate = useAxios();
  const axiosUpdate = useAxios();
  const axiosDelete = useAxios();

  const getAllQuickLinks = async () => {
    await axiosList.fetchData({
      url: `/xadmin/quick-links`,
      method: "GET",
    });
  };

  const createQuickLink = async (data) => {
    return await axiosCreate.fetchData({
      url: `/xadmin/quick-links`,
      method: "POST",
      data,
    });
  };

  const updateQuickLink = async (id, data) => {
    return await axiosUpdate.fetchData({
      url: `/xadmin/quick-links/${id}`,
      method: "PUT",
      data,
    });
  };

  const deleteQuickLink = async (id) => {
    return await axiosDelete.fetchData({
      url: `/xadmin/quick-links/${id}`,
      method: "DELETE",
    });
  };

  return {
    getAllQuickLinks,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,

    createQuickLink,
    createLoading: axiosCreate.loading,

    updateQuickLink,
    updateLoading: axiosUpdate.loading,

    deleteQuickLink,
    deleteLoading: axiosDelete.loading,
  };
};

export default useQuickLinkService;
